import { Button } from "@shared/ui";
import footerStyles from "./ScriptBulkAttachFooter.module.scss";
import styles from "./styles.module.scss";

interface ScriptBulkAttachFooterProps {
  attachCount: number;
  isAttaching?: boolean;
  // onUploadScript: () => void;
  onAttach: () => void;
}

export function ScriptBulkAttachFooter({
  attachCount,
  isAttaching,
  // onUploadScript,
  onAttach,
}: ScriptBulkAttachFooterProps) {
  return (
    <div className={`${styles.scriptFooter} ${footerStyles.bar}`}>
      {/* <Button
        onClick={onUploadScript}
        disabled={isAttaching}
        className={footerStyles.button}
      >
        <Upload size={14} />
        Upload script
      </Button> */}
      <Button
        type="primary"
        loading={isAttaching}
        onClick={onAttach}
        className={footerStyles.attachButton}
      >
        Attach to {attachCount} creator{attachCount === 1 ? "" : "s"}
      </Button>
    </div>
  );
}
